import { useMediumQuery } from '@lib/hooks/useMediumQuery';
import { actions } from '@store/ducks/auth';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import TStore from 'types/store';
import ChevronButton from '../../../components/chevron-button';
import Header from '../../../components/header';
import { STEPS } from '../../../registration/registration.types';
import { StepSuccessSC } from './step-success.styled';

const StepSuccess: React.FC = () => {
  const isScreenNarrow = useMediumQuery('(max-width: 900px)');
  const role = useSelector((state: TStore) => state.auth.role);
  const step = useSelector((state: TStore) => state.auth.currentRegStep);
  const dispatch = useDispatch();

  const handleButtonClick = () => {
    if (role === 'patient') {
      dispatch(actions.setCurrentRegStep(STEPS.PATIENT_ONLY));
    } else {
      dispatch(actions.getTryLoginRequest());
    }
  };

  return (
    <StepSuccessSC>
      <Header
        textId={isScreenNarrow ? 'reg.step_success.title' : 'reg.step_success.full'}
        step={step}
      />
      {isScreenNarrow && (
        <span className="text">
          <FormattedMessage id="reg.step_success.copy" />
        </span>
      )}
      {role !== 'patient' && isScreenNarrow ? (
        <span className="desktop-only">
          <FormattedMessage id="reg.step_success.desktop-only" />
        </span>
      ) : (
        <ChevronButton
          textId="reg.step_0.btn_text"
          goForth={handleButtonClick}
          className="next-button"
        />
      )}
    </StepSuccessSC>
  );
};

export default StepSuccess;
